// One bike rack or locker bank, opened by tapping its circle on the map.
//
// The same card a parking lot gets, and deliberately so: both are "you tapped a
// mark on the map, here is what it is". What differs is the one thing you can
// do about it, and it differs in the bike's favour — a rack sits ON the walking
// network (it is a node, not a polygon), so it can be routed to, where a car
// lot cannot. That button is most of the reason to open this at all: knowing
// there are lockers at Extended Education is no use without knowing they are
// eight minutes away on the other side of campus.
//
// There is no schedule, no price and no capacity in the data, so the card says
// only what is true: the name, whether it is lockers or an open rack, and the
// way there. Padding it with plausible facts would be the one failure mode that
// matters for something somebody is about to leave a bicycle at.
import MapInfoCard from './MapInfoCard.jsx';
import { BIKE_COLOR, bikeKindLabel } from '../lib/bikes.js';

export default function BikeParkingCard({ spot, onGo, onClose }) {
  if (!spot) return null;
  return (
    <MapInfoCard
      color={BIKE_COLOR}
      title={spot.name}
      status={{ text: bikeKindLabel(spot.kind), tone: 'free' }}
      facts={[
        // Lockers are the fact worth spelling out: they are the reason to ride
        // to this one rather than the nearer rack, and "lockers" in a name is
        // easy to miss.
        ['Type', spot.kind === 'lockers'
          ? 'Enclosed lockers'
          : 'Open racks — bring a lock'],
      ]}
      action={onGo ? { label: 'Directions', onClick: onGo } : null}
      onClose={onClose}
    />
  );
}
